onComplete(function () {

	const header = document.querySelector('header.nav-header');
	const navLinks = document.querySelectorAll('header.nav-header .nav-link');
	const navToggler = document.querySelectorAll('.nav-header .navbar-toggler-icon i');
	const navLogo = document.querySelector('header.nav-header .navbar-brand .logo');
	const navSecondaryBtns = document.querySelectorAll('header.nav-header .btn-secondary');

	const diafragmaPrimarySrc = new URL('static/assets/DIAFRAGMA-primary.webp', document.baseURI).href;
	const diafragmaWhiteSrc = new URL('static/assets/DIAFRAGMA.webp', document.baseURI).href;

	let prevScrollPos = document.documentElement.scrollTop;
	let currentScrollPos = document.documentElement.scrollTop;

	const updateHeaderStyle = function () {

		if (currentScrollPos > 50) {
			header.style.backgroundColor = "var(--white)";
			header.style.boxShadow = "var(--box-shadow-2)";
			navLogo.setAttribute('src', 'static/assets/logo-primary.svg');
			navLinks.forEach(link => {
				link.style.color = "var(--primary)";
			});
			navToggler.forEach(toggler => {
				toggler.style.backgroundColor = "var(--background)";
			});
			navSecondaryBtns.forEach(btn => {
				btn.style.color = "var(--primary)";
				btn.style.setProperty('--nav-btn-bg-image', `url("${diafragmaPrimarySrc}")`);
			});
		} else {
			header.style.backgroundColor = "";
			header.style.boxShadow = "";
			navLinks.forEach(link => {
				link.style.color = "";
			});
			navToggler.forEach(toggler => {
				toggler.style.backgroundColor = "";
			});
			navSecondaryBtns.forEach(btn => {
				btn.style.color = "";
				btn.style.setProperty(
					'--nav-btn-bg-image',
					document.querySelector('.header-work')
						? `url("${diafragmaWhiteSrc}")`
						: `url("${diafragmaPrimarySrc}")`
				);
			});
			navLogo.setAttribute(
				'src',
				document.querySelector('.header-work')
					? 'static/assets/logo.svg'
					: 'static/assets/logo-primary.svg'
			);

		}

	};

	updateHeaderStyle();

	window.addEventListener('scroll', function () {

		currentScrollPos = document.documentElement.scrollTop;

		if (document.body.matches('[data-editor-mode="content"]')) {
			prevScrollPos = currentScrollPos;
			updateHeaderStyle();
			return;
		}

		if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
			header.style.translate = "0 0";
		} else {
			header.style.translate = "0 -100%";
		}
		prevScrollPos = currentScrollPos;

		updateHeaderStyle();

	});
	// wizard width

	const updateWizardWidth = () => {
		const wizardIndicators = document.querySelector('.wizard-indicators');

		if (wizardIndicators) {
			document.documentElement.style.setProperty(
				'--wizard-width',
				`${wizardIndicators.offsetWidth}px`
			);

			document.documentElement.style.setProperty(
				'--wizard-count',
				wizardIndicators.children.length
			);
		}
	};

	updateWizardWidth();

	window.addEventListener('resize', updateWizardWidth);

	// navheader mobile

	const navHeader = document.querySelector('.nav-header');

	const updateHeaderHeight = () => {
		if (navHeader) {
			document.documentElement.style.setProperty(
				'--header-height',
				`${navHeader.offsetHeight}px`
			);
		}
	};

	if (navHeader) {
		updateHeaderHeight();

		new ResizeObserver(updateHeaderHeight).observe(navHeader);

		window.addEventListener('resize', updateHeaderHeight);
	};
});
